(function () {
  'use strict';

  var search = document.querySelector('[data-predictive-search]');
  if (!search) return;

  var input = search.querySelector('[data-predictive-input]');
  var results = search.querySelector('[data-predictive-results]');
  var closeButton = search.querySelector('[data-search-close]');
  var timer;
  var controller;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function formatPrice(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: search.dataset.currency || 'USD'
      }).format(amount);
    } catch (error) {
      return String(value);
    }
  }

  function showMessage(message) {
    results.innerHTML = '<p class="search-panel__message">' + escapeHtml(message) + '</p>';
  }

  function renderProducts(products, query) {
    if (!products.length) {
      showMessage(search.dataset.empty);
      return;
    }

    var cards = products.map(function (product) {
      var image = product.image || product.featured_image || '';
      var imageUrl = typeof image === 'string' ? image : (image.url || '');
      if (imageUrl) imageUrl += imageUrl.indexOf('?') === -1 ? '?width=360' : '&width=360';
      var price = formatPrice(product.price);
      return '<a class="search-product" href="' + escapeHtml(product.url) + '">' +
        '<span class="search-product__image">' + (imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy" width="180" height="120">' : '') + '</span>' +
        '<span class="search-product__title">' + escapeHtml(product.title) + '</span>' +
        (price ? '<span class="search-product__price">' + escapeHtml(price) + '</span>' : '') +
      '</a>';
    }).join('');

    var searchUrl = new URL(search.dataset.searchUrl, window.location.origin);
    searchUrl.searchParams.set('q', query);
    searchUrl.searchParams.set('options[prefix]', 'last');
    results.innerHTML = '<div class="search-panel__heading">' + escapeHtml(search.dataset.heading) + '</div>' +
      '<div class="search-panel__grid">' + cards + '</div>' +
      '<a class="search-panel__all" href="' + escapeHtml(searchUrl.toString()) + '">' + escapeHtml(search.dataset.viewAll) + ' <span aria-hidden="true">→</span></a>';
  }

  function fetchProducts(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    results.setAttribute('aria-busy', 'true');
    showMessage('…');

    var endpoint = new URL(search.dataset.suggestUrl, window.location.origin);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '6');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
    endpoint.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

    fetch(endpoint.toString(), { headers: { Accept: 'application/json' }, signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) {
        if (input.value.trim() !== query) return;
        var products = data.resources && data.resources.results && data.resources.results.products || [];
        renderProducts(products, query);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError' && input.value.trim() === query) showMessage(search.dataset.empty);
      })
      .finally(function () { results.removeAttribute('aria-busy'); });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    input.setAttribute('aria-expanded', query.length >= 2 ? 'true' : 'false');
    window.clearTimeout(timer);
    if (controller) controller.abort();
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    timer = window.setTimeout(function () { fetchProducts(query); }, 220);
  });

  search.addEventListener('toggle', function () {
    if (search.open) {
      window.requestAnimationFrame(function () { input.focus(); });
    } else {
      input.setAttribute('aria-expanded', 'false');
      results.innerHTML = '';
      if (controller) controller.abort();
    }
  });

  closeButton.addEventListener('click', function () {
    search.open = false;
    search.querySelector('summary').focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && search.open) {
      search.open = false;
      search.querySelector('summary').focus();
    }
  });
}());

